'use client';

import { useEffect } from 'react';

export default function ViewportFix() {
  useEffect(() => {
    function setVH() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    // Initial call
    setVH();

    // Event listeners
    const handleResize = () => setVH();
    const handleOrientationChange = () => setTimeout(setVH, 100);

    window.addEventListener('resize', handleResize, { passive: true });
    window.addEventListener('orientationchange', handleOrientationChange, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  return null;
} 